import { useQuery } from "@tanstack/react-query";

import api from "@/shared/api";
import { DataMany } from "@/shared/types.ts";

export type FocusRecord = {
  id: number;
  createdAt: string;
  orderId: number;
  orderPackageId: number | null;
  userId: string;
  identification: string | null;
  target: string | null;
  description: string | null;
  latitude: number | null;
  longitude: number | null;
};

export function useFocusList({
  userId,
  orderId,
  page = 1,
  limit = 20,
  enabled = true,
}: {
  userId?: string;
  orderId?: string;
  page?: number;
  limit?: number;
  enabled?: boolean;
}) {
  return useQuery<DataMany<FocusRecord[]>>({
    queryKey: ["focus", userId ?? "", orderId ?? "", page, limit],
    queryFn: () => {
      const searchParams: Record<string, string | number> = { page, limit };
      if (userId) searchParams.userId = userId;
      if (orderId) searchParams.orderId = orderId;

      return api
        .get<DataMany<FocusRecord[]>>(`/api/v1/focus`, { searchParams })
        .json();
    },
    enabled,
    placeholderData: (prev) => prev,
  });
}
